import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const update = ({ userId, ratingId, rating, feedback }) => {
    return axios.patch(urlGenerator.userCourseRating(userId, ratingId), { rating, feedback }, createRequestConfig()).then(property('data'))
}

export default {
    update,
}